<div [formGroup]="control" class="container mx-auto">
  <evc-quote-charging-station-placement
    *ngIf="activeStep === chargingStationDetailsSteps.placement"
    formControlName="placement"
    (formReady)="goToStep(chargingStationDetailsSteps.accessBadge)"
    (goBack)="navigateBack()"
  ></evc-quote-charging-station-placement>

  <evc-quote-charging-station-access-badge
    *ngIf="activeStep === chargingStationDetailsSteps.accessBadge"
    formControlName="accessBadge"
    (formReady)="navigate()"
    (goBack)="goToStep(chargingStationDetailsSteps.placement)"
  ></evc-quote-charging-station-access-badge>
</div>
